import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col } from 'antd';

export default class GuarantorInfo extends React.Component {
  render() {
    const { t, guarantor, payload } = this.props;
    return (
      <div>
        <div className="longtail-booking-details__block-row-container">
          <Row gutter={50} className="longtail-booking-details__block-row">
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.guarantor_info.first_name', {
                  value: guarantor && guarantor.firstName ? guarantor.firstName : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.guarantor_info.relationship', {
                  value:
                    guarantor && guarantor.relationshipWithStudent
                      ? t(
                          `landlord.long_tail.booking_details.field.relationship.${guarantor.relationshipWithStudent.toLowerCase()}`,
                        )
                      : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.email', {
                  value:
                    guarantor && guarantor.emailAddress
                      ? this.props.hiddenEmailByStatus(
                          guarantor.emailAddress,
                          payload.stage,
                          payload.secondaryStage,
                        )
                      : '-',
                })}
              </p>
            </Col>
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.guarantor_info.last_name', {
                  value: guarantor && guarantor.lastName ? guarantor.lastName : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.date_of_birth', {
                  value:
                    guarantor && guarantor.dateOfBirth
                      ? moment(guarantor.dateOfBirth).format('DD/MM/YYYY')
                      : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.mobile', {
                  value:
                    guarantor && guarantor.phone
                      ? this.props.hiddenPhoneByStatus(
                          guarantor.phone,
                          payload.stage,
                          payload.secondaryStage,
                        )
                      : '-',
                })}
              </p>
            </Col>
          </Row>
        </div>
        <div className="longtail-booking-details__block-row-container">
          <Row gutter={50} className="longtail-booking-details__block-row">
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.country', {
                  value: guarantor && guarantor.country ? guarantor.country : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.city', {
                  value: guarantor && guarantor.city ? guarantor.city : '-',
                })}
              </p>
            </Col>
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.state', {
                  value: guarantor && guarantor.state ? guarantor.state : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.postal', {
                  value: guarantor && guarantor.postalCode ? guarantor.postalCode : '-',
                })}
              </p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

GuarantorInfo.propTypes = {
  t: PropTypes.func,
  guarantor: PropTypes.object,
  payload: PropTypes.object,
  hiddenPhoneByStatus: PropTypes.func,
  hiddenEmailByStatus: PropTypes.func,
};

GuarantorInfo.defaultProps = {
  t: () => {},
  guarantor: {},
  payload: {},
  hiddenPhoneByStatus: () => {},
  hiddenEmailByStatus: () => {},
};
